const DEV_HOSTNAMES = new Set([
  'localhost',
  '127.0.0.1',
  'selfservice-frontend-dev.onrender.com',
]);

export const isSelfServiceDevelopment = (): boolean => {
  const env = import.meta.env.VITE_ENVIRONMENT;
  if (env === 'development' || env === 'dev') return true;
  if (env === 'production' || env === 'prod') return false;
  if (import.meta.env.DEV) return true;
  if (typeof window === 'undefined') return false;
  return DEV_HOSTNAMES.has(window.location.hostname);
};
